import { Divider, Stepper as MuiStepper, Step, StepLabel } from '@mui/material'

import { StepIcon } from './step-icon'

interface Props {
  activeStep: number
  steps: number
}

export function Stepper({ activeStep, steps }: Props) {
  return (
    <MuiStepper
      activeStep={activeStep}
      connector={<Divider sx={{ minWidth: 24, maxWidth: 100, flex: 1, borderWidth: 1 }} />}
      sx={{ justifyContent: 'center', p: 1.5 }}
    >
      {Array.from({ length: steps }, (_, i) => (
        <Step key={i} sx={{ px: 0 }}>
          <StepLabel
            StepIconComponent={StepIcon}
            sx={{
              p: 0,
              '& .MuiStepLabel-iconContainer': { p: 0 },
            }}
          />
        </Step>
      ))}
    </MuiStepper>
  )
}
